//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  methods: {
    closeWx() {
      // eslint-disable-next-line
      wx.closeWindow()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/login/smSuccess.vue